import React, { createContext } from 'react';

export type GlobalShortcutsDragAndDropIndex = number;
export type GlobalShortcutsDragAndDropChangeEvent = (
	order: GlobalShortcutsDragAndDropIndex[],
) => void;

// Drag and Drop Context Provider
type DragAndDropOptionsContextType = {
	enabled: boolean;
	handleDragAndDropChange?: GlobalShortcutsDragAndDropChangeEvent;
};

export const DragAndDropOptionsContext = createContext<DragAndDropOptionsContextType>({
	enabled: false,
});

// Drag and Drop Provider Component
export type DragAndDropOptionsProviderProps = {
	children: React.ReactNode;
	enabled?: boolean;
	handleDragAndDropChange?: GlobalShortcutsDragAndDropChangeEvent;
};
export const DragAndDropOptionsProvider = ({
	children,
	enabled = false,
	handleDragAndDropChange,
}: DragAndDropOptionsProviderProps) => {
	return (
		<DragAndDropOptionsContext.Provider value={{ enabled, handleDragAndDropChange }}>
			{children}
		</DragAndDropOptionsContext.Provider>
	);
};
